import { getChartsRequest, getAiCreditsRequest } from "./request";
import { useQuery } from "react-query";


export const useFetchCharts = () => {
    return useQuery(["UseCharts"], getChartsRequest);
};

export const useFetchAiCredits = ({ users, startDate, endDate } = {}) => {
    return useQuery(["UseAiCredits", users, startDate, endDate], () =>
        getAiCreditsRequest({ users, startDate, endDate })
    );
};